export default __webpack_public_path__ + "static/media/1913.a64b032b.png";